export default function wppVisibility() {
    const wpp    = document.querySelector('.wpp-float');
    const footer = document.querySelector('footer');
    if (!wpp || !footer) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            wpp.classList.toggle('wpp-hidden', entry.isIntersecting);
        },
        { threshold: 0 }
    );

    observer.observe(footer);
}
